import axios from 'axios'
import { TSaleSummaryReportsResponse } from './_models'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const REPORTS_URL = `${API_URL}/reports`

const getSaleSummaryReportById = (filter: string): Promise<TSaleSummaryReportsResponse> => {
  return axios
    .get(`${REPORTS_URL}/summary-growth-month${filter ? `?filter_by_month_year=${filter}` : ''}`)
    .then((response: any) => response.data)
}

export {getSaleSummaryReportById};